import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import Autocomplete from "../AutocompleteForms";
import AutocompleteInputModule from "../AutoComplete";
import ReactSelect from "react-select";
import EliminarElemento from "../EliminarElemento";
import EmptyTableRow from "../EmptyTableRow";

function Etapa(props) {
  const { history } = props;
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  const [paginas, setPaginas] = useState(0);

  const [etapaStateUpdate, setetapaStateUpdate] = useState([]);
  const [etapaState, setetapaState] = useState([]);
  // eslint-disable-next-line
  const [listaEtapas, setListaEtapas] = useState([]);

  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(true);
  const [buscarState, setBuscarState] = useState(true);
  const [stageTypes, setStageTypes] = useState([]);
  const [notebooks, setNotebooks] = useState([]);
  const [units, setUnits] = useState([]);
  const [clients, setClients] = useState([]);

  const [formularioUpdate, setformularioUpdate] = useState({});
  // eslint-disable-next-line
  useEffect(async () => {
    let listaEtapas = await fetch(
      Parametros.urlApi + "stages?&limit=5000&is_mantenedor=true",
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    );

    if (listaEtapas.status === 200 || listaEtapas.status === 201) {
      let listaEtapasResponse = await listaEtapas.json();

      setListaEtapas(listaEtapasResponse.data);
    } else if (listaEtapas.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
    }
  }, [update, usuario, history]);
  // eslint-disable-next-line
  useEffect(() => {
    async function llamadaApi() {
      let busquedaName;
      let busquedaIDinternal;
      try {
        if (formularioBusqueda.name) {
          busquedaName = "&name=" + formularioBusqueda.name;
        } else {
          busquedaName = "";
        }

        if (formularioBusqueda.internal_id) {
          busquedaIDinternal = "&internal_id=" + formularioBusqueda.internal_id;
        } else {
          busquedaIDinternal = "";
        }
      } catch {}
      let response = await fetch(
        Parametros.urlApi +
          "stages?skip=" +
          paginacionState.skip +
          "&limit=" +
          paginacionState.limit +
          busquedaName +
          busquedaIDinternal,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
          body: null,
        }
      );

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        setPaginas(responseJson.n_pages);
        let responseJsonUpdate = JSON.stringify(responseJson.data);
        let responseJsonstate = JSON.stringify(responseJson.data);
        setetapaStateUpdate(JSON.parse(responseJsonUpdate));
        setetapaState(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }

    llamadaApi();
    // eslint-disable-next-line
  }, [update, paginacionState, buscarState]);

  const [formularioBusqueda, setFormularioBusqueda] = useState({});

  let handleFormBusqueda = (e) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerT;

    let estadoUpdate = formularioBusqueda;
    estadoUpdate[name] = value;

    setFormularioBusqueda(JSON.parse(JSON.stringify(estadoUpdate)));
  };

  let buscarEtapa = (e) => {
    setBuscarState(!buscarState);
  };

  useEffect(() => {
    fetch(Parametros.urlApi + "stages_types", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => res.json())
      .then((data) => setStageTypes(data));
    fetch(Parametros.urlApi + "notebooks", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => res.json())
      .then((data) => setNotebooks(data));
    fetch(Parametros.urlApi + "units", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => res.json())
      .then((data) => setUnits(data));
    fetch(Parametros.urlApi + "clients", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
      },
    })
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => setClients(Array.isArray(data) ? data : []))
      .catch(() => setClients([]));
  }, [usuario.key]);

  const [formularioState, setFormularioState] = useState({
    name: "",
    parent: null,
    internal_id: "",
    stage_type: "",
    client: "",
    units: [],
    notebooks: [],
  });

  const [editable, setEditable] = useState({
    id: "",
  });

  let handleStageForm = (e) => {
    e.preventDefault();

    const value = e.target.value ? e.target.value : e.currentTarget.innerText;
    const name = e.target.getAttribute("name");

    //
    setFormularioState({
      ...formularioState,
      [name]: value,
    });

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  let crearEtapa = async (event) => {
    event.preventDefault();

    const formToSubmit = {
      ...formularioState,
      units: formularioState.units.map((item) => item.value),
      notebooks: formularioState.notebooks.map((item) => item.value),
    };

    if (usuario.permisos.indexOf("Crear") > -1) {
      for (const key in formularioState) {
        if (!formularioState[key] && key !== "parent") {
          return alert("Debe completar los campos obligatorios");
        }
      }
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.post + "stages/", {
          method: "POST",
          body: JSON.stringify(formToSubmit),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          alert("ok");
          setFormularioState({
            name: "",
            parent: null,
            internal_id: "",
            stage_type: "",
            client: "",
            notebooks: [],
            units: [],
          });
          setformularioUpdate({ internal_id: "", name: "" });
          setUpdate(!update);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setUpdate(!update);
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };

  let etapaHandleChange = (index, e) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    let newList = etapaState;
    newList[index][name] = value;
    setetapaState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  let confirmarEdicion = async (item) => {
    let formToSubmit = {
      ...formularioUpdate,
    };
    if (formularioUpdate.notebooks) {
      formToSubmit.notebooks = formularioUpdate.notebooks.map((o) => o.value);
    }
    if (formularioUpdate.units) {
      formToSubmit.units = formularioUpdate.units.map((o) => o.value);
    }

    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(
          Parametros.urlApi + "stages/" + item.stage_id,
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(formToSubmit),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setEditable({});
          alert(responseJson.message);

          setUpdate(!update);
          setFormularioState({});
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setEditable({});
          setUpdate(!update);
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.editar);
    }
  };
  let cancelarEdicion = () => {
    const nuevoObjeto = JSON.parse(JSON.stringify(etapaStateUpdate));
    setetapaState(nuevoObjeto);
    setEditable({});
  };
  let editar = (id) => {
    setetapaState(JSON.parse(JSON.stringify(etapaStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };

  const handleChangeNotebooks = (opts) => {
    setFormularioState({
      ...formularioState,
      notebooks: opts,
    });
  };

  const handleChangeUnits = (opts) => {
    setFormularioState({
      ...formularioState,
      units: opts,
    });
  };

  const handleChangeNotebooksUpdate = (opts) => {
    setformularioUpdate({
      ...formularioUpdate,
      notebooks: opts,
    });
  };

  const handleChangeUnitsUpdate = (opts) => {
    setformularioUpdate({
      ...formularioUpdate,
      units: opts,
    });
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Etapa"}></UserTab>
        <form id="formularioBusqueda" onSubmit={crearEtapa}>
          <div className="col-md-4">
            <h5>Nombre etapa</h5>
            <input
              onChange={handleStageForm}
              value={formularioState.name}
              name="name"
              required
              className="form-control"
            ></input>
          </div>
          <div className="col-md-4">
            <h5>ID interna</h5>
            <input
              onChange={handleStageForm}
              value={formularioState.internal_id}
              name="internal_id"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Etapa Relacionada</h5>
            <Autocomplete
              personalHandleChange={handleStageForm}
              setformularioUpdate={setformularioUpdate}
              formularioUpdate={formularioUpdate}
              formularioBuscado={formularioState}
              setformulario={setFormularioState}
              nameElement={"parent"}
              key={update}
              value={formularioState.parent}
              suggestions={listaEtapas.map((item) => {
                return { value: item.stage_id, label: item.name };
              })}
            ></Autocomplete>
          </div>

          <div className="col-md-4">
            <h5>Tipo de Etapa</h5>
            <Autocomplete
              personalHandleChange={handleStageForm}
              setformularioUpdate={setformularioUpdate}
              formularioUpdate={formularioUpdate}
              formularioBuscado={formularioState}
              setformulario={setFormularioState}
              nameElement={"stage_type"}
              key={update}
              value={formularioState.stage_type}
              suggestions={stageTypes.map((item) => {
                return { value: item.stage_type_id, label: item.name };
              })}
            ></Autocomplete>
          </div>

          <div className="col-md-4">
            <h5>Mandante</h5>
            <Autocomplete
              personalHandleChange={handleStageForm}
              setformularioUpdate={setformularioUpdate}
              formularioUpdate={formularioUpdate}
              formularioBuscado={formularioState}
              setformulario={setFormularioState}
              nameElement={"client"}
              key={update}
              value={formularioState.client}
              suggestions={clients.map((item) => {
                return { value: item.client_id, label: item.name };
              })}
            ></Autocomplete>
          </div>

          <div className="col-md-4">
            <h5>Cuadernos</h5>
            <ReactSelect
              isMulti
              value={formularioState.notebooks}
              onChange={handleChangeNotebooks}
              options={notebooks.map((item) => ({
                value: item.notebook_id,
                label: item.name,
              }))}
            />
          </div>

          <div className="col-md-4">
            <h5>Unidades</h5>
            <ReactSelect
              isMulti
              value={formularioState.units}
              onChange={handleChangeUnits}
              options={units.map((item) => ({
                value: item.unit_id,
                label: item.name,
              }))}
            />
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <form id="formularioBusqueda">
          <div className="col-md-4">
            <h5>Nombre etapa</h5>
            <input
              onChange={handleFormBusqueda}
              defaultValue=""
              name="name"
              required
              className="form-control"
            ></input>
          </div>
          <div className="col-md-4">
            <h5>ID interna</h5>
            <input
              onChange={handleFormBusqueda}
              defaultValue=""
              name="internal_id"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="button"
              onClick={(e) => {
                buscarEtapa(e);
              }}
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Buscar
            </button>
          </div>
        </form>
        <div
          className="col-md-12 table-responsive"
          style={{ width: "100%" }}
        >
          <Table
            type={1}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            paginationBelow={true}
            elementos={[
              "ID interna",
              "Nombre etapa",
              "Etapa Relacionada",
              "Tipo de Etapa",
              "Mandante",
              "Cuadernos",
              "Unidades",
              "Activo",
            ]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table
              type={2}
              elementos={[
                "ID interna",
                "Nombre etapa",
                "Etapa Relacionada",
                "Tipo de Etapa",
                "Cuadernos",
                "Unidades",
                "Activo",
              ]}
            ></Table>

            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {etapaState.length === 0 && (
                  <EmptyTableRow colSpan={8} />
                )}
                {etapaState.map((item, index) => {
                  return (
                    <tr key={item.stage_id}>
                      {editable === item.stage_id ? (
                        <>
                          <td>{item.stage_id}</td>
                          <td>{item.internal_id}</td>
                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                etapaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>

                          <td>
                            {" "}
                            <AutocompleteInputModule
                              name={"parent"}
                              suggestions={listaEtapas.map((etapa) => {
                                return {
                                  value: etapa.stage_id,
                                  label: etapa.name,
                                };
                              })}
                              i={index}
                              value={item.parent}
                              setformularioUpdate={setformularioUpdate}
                              formularioUpdate={formularioUpdate}
                              setState={setetapaState}
                              state={etapaState}
                            ></AutocompleteInputModule>
                          </td>

                          <td>
                            <AutocompleteInputModule
                              name={"stage_type"}
                              suggestions={stageTypes.map((etapa) => {
                                return {
                                  value: etapa.stage_type_id,
                                  label: etapa.name,
                                };
                              })}
                              i={index}
                              value={item.stage_type}
                              setformularioUpdate={setformularioUpdate}
                              formularioUpdate={formularioUpdate}
                              setState={setetapaState}
                              state={etapaState}
                            ></AutocompleteInputModule>
                          </td>

                          <td>
                            <AutocompleteInputModule
                              name={"client"}
                              suggestions={clients.map((cli) => {
                                return {
                                  value: cli.client_id,
                                  label: cli.name,
                                };
                              })}
                              i={index}
                              value={item.client_id}
                              setformularioUpdate={setformularioUpdate}
                              formularioUpdate={formularioUpdate}
                              setState={setetapaState}
                              state={etapaState}
                            ></AutocompleteInputModule>
                          </td>

                          <td>
                            <ReactSelect
                              isMulti
                              value={
                                formularioUpdate.notebooks
                                  ? formularioUpdate.notebooks
                                  : item.notebooks.map((item) => ({
                                      label: item.name,
                                      value: item.notebook_id,
                                    }))
                              }
                              onChange={handleChangeNotebooksUpdate}
                              options={notebooks.map((item) => ({
                                label: item.name,
                                value: item.notebook_id,
                              }))}
                            />
                          </td>

                          <td>
                            <ReactSelect
                              isMulti
                              value={
                                formularioUpdate.units
                                  ? formularioUpdate.units
                                  : item.units.map((item) => ({
                                      label: item.name,
                                      value: item.unit_id,
                                    }))
                              }
                              onChange={handleChangeUnitsUpdate}
                              options={units.map((item) => ({
                                label: item.name,
                                value: item.unit_id,
                              }))}
                            />
                          </td>

                          <td>{item.is_active ? "Activo" : "Inactivo"}</td>

                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.stage_id}</td>
                          <td>{item.internal_id}</td>
                          <td>{item.name} </td>

                          <td>
                            {listaEtapas.map((etapa) => {
                              if (etapa.stage_id === item.parent) {
                                return etapa.name;
                              } else {
                                return "";
                              }
                            })}
                          </td>

                          <td>{item.stage_type_name} </td>

                          <td>{item.client_name || ""}</td>

                          <td style={{ textAlign: "start", paddingLeft: 16 }}>
                            {item.notebooks.map((i) => (
                              <div key={i.notebook_id}>- {i.name}</div>
                            ))}
                          </td>

                          <td style={{ textAlign: "start", paddingLeft: 16 }}>
                            {item.units.map((i) => (
                              <div key={i.unit_id}>- {i.name}</div>
                            ))}
                          </td>
                          <td>{item.is_active ? "Activo" : "Inactivo"}</td>

                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.stage_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              method="PUT"
                              endpoint={`stage/active/${item.stage_id}?active=false`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
        </div>
      </div>
    </div>
  );
}

export default withRouter(Etapa);
